import * as jose from "jose";

export type JwtPayload = {
  sub: string;
  member_id: string;
};

const getSecret = () =>
  new TextEncoder().encode(
    process.env.CSR_CHAT_JWT_SECRET ?? "Rajan.Twanabashu",
  );

export const generateToken = async (payload: JwtPayload): Promise<string> => {
  return new jose.SignJWT({ ...payload })
    .setProtectedHeader({ alg: "HS256" })
    .setIssuedAt()
    .setExpirationTime("1h")
    .sign(getSecret());
};

export const verifyToken = async (token: string): Promise<JwtPayload> => {
  const { payload } = await jose.jwtVerify(token, getSecret());
  return {
    sub: payload.sub as string,
    member_id: payload["member_id"] as string,
  };
};

export const decodeToken = (token: string): jose.JWTPayload | null => {
  try {
    return jose.decodeJwt(token);
  } catch {
    return null;
  }
};
